import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { LocalStorageService } from '../services/storage/local-storage.service';

export const notLoggedInGuard: CanActivateFn = () => {
  const router = inject(Router);
  const localStorage = inject(LocalStorageService);
  const isLoggedIn = localStorage.get('token');
  if (isLoggedIn) {
    router.navigate(['/']);
  }
  return !isLoggedIn;
};
